/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { mapObjIndexed, prop } from 'ramda'
import React from 'react'

import { Grid } from '../structure/Grid'
import { getSmartSize } from '../../utils/helpers/styles'
import { useColorableSpaceStyle } from '../../utils/styles/colorableSpace'
import ConditionalLink from '../actions/ConditionalLink'
import Text from '../presentation/Text'

export const Tags = ({ values, children, ...props }) => (
  <Grid justify="flex-start" align="center" gutter={0.2} wrap flex={1} {...props}>
    {values.map((value, index) => (
      <Tag key={`${value}-${index}`} label={value} {...props} />
    ))}
  </Grid>
)

export const SIZES = {
  xsmall: { width: 3, height: 0.2, fontSize: 'xxxsmall' },
  small: { width: 3, height: 1, fontSize: 'xxsmall' },
  normal: { width: 3, height: 1.2, fontSize: 'xsmall' },
  large: { width: 5, height: 1.4, fontSize: 'small' },
  xlarge: { width: 7, height: 1.6, fontSize: 'p' }
}

const Tag = ({ children, size, onClick, type, label, ...props }) => {
  size = size || 'normal'
  const fontSizeValue = getSmartSize(size, mapObjIndexed(prop('fontSize'), SIZES), 'p')
  const [colorableSpaceStyle, fontColor] = useColorableSpaceStyle({
    size,
    sizes: SIZES,
    paddingH: 0.3,
    paddingV: 0,
    radius: 0.3,
    ...props
  })
  const style = css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    ${colorableSpaceStyle}
  `

  return (
    <ConditionalLink onClick={onClick}>
      <span className="tag" css={style}>
        <Text size={fontSizeValue} align="center" color={fontColor} bold>
          {label || children}
        </Text>
      </span>
    </ConditionalLink>
  )
}

export default Tag
